import axios from "axios";
import FormData from "form-data";
import { REPAIR_XD_FILE_ENDPOINTS } from "@/constants/backend";

export type IFileToRepairUploadStatus = "inProgress" | "done" | "failed";

interface IUploadFileToRepairResponse {
  fileName: string;
}

export interface IFileToRepairUploadStatusResponse {
  original: IFileToRepairUploadStatus;
  repaired: IFileToRepairUploadStatus;
}

export interface IRepairedFileDownloadUrlResponse {
  original: string;
  repaired: string;
}

/**
 * @returns uploaded file name
 */
export const uploadFileToRepair = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);

  const result = await axios.post<IUploadFileToRepairResponse>(
    REPAIR_XD_FILE_ENDPOINTS.upload,
    formData,
  );
  return result.data.fileName;
};

export const getFileToRepairUploadStatus = async (
  fileName: string,
): Promise<IFileToRepairUploadStatusResponse> => {
  const result = await axios.get<IFileToRepairUploadStatusResponse>(
    REPAIR_XD_FILE_ENDPOINTS.uploadStatus,
    {
      params: { fileName },
    },
  );
  return result.data;
};

export const repairFile = async (fileName: string): Promise<void> => {
  await axios.post(
    REPAIR_XD_FILE_ENDPOINTS.repair,
    {},
    { params: { fileName } },
  );
};

export const fetchRepairedFileDownloadInfo = async (
  fileName: string,
): Promise<IRepairedFileDownloadUrlResponse> => {
  const result = await axios.get(REPAIR_XD_FILE_ENDPOINTS.downloadUrl, {
    params: { fileName },
  });
  return result.data;
};
